import CustomFieldProto from '../../proto/custom-field-proto';
import ListComponent from './components/rating-list';
import ListGroupHeaderComponent from './components/rating-group-list-header';
import TListGroupHeader1Component from './components/rating-group-t-list-header-1';
import ViewComponent from './components/rating-view';
import EditComponent from "./components/edit";
import FormComponent from "./components/form";
import FormNewComponent from './components/rating-form-new';
import AggregateNumber from "../../aggregate/aggregate-number";
import AggregateRatingComponent from "./components/aggregate-rating";
import normalizeNumber from "../../import/normalize/normalize-number";
import FieldRatingViewInImport from "./components/rating-view-in-import";

export default class RatingCustomField extends CustomFieldProto {

    constructor(customField) {
        super(customField);

        this.formulaCompatible = true;
    }

    _normalizeRatingValue(value) {
        const { params } = this.customField;

        let res = value ? value : null;
        if (!_.isNil(res)) {
            switch (params.ratingType) {
                case 5: if (res > 5) res = 5; break;
                case 3: if (res > 3) res = 3; break;
            }
        }

        return res;
    };

    getCsvValue(item) {
        const { customFieldsData } = item;
        return !!customFieldsData[this.customField.id] ? this._normalizeRatingValue(customFieldsData[this.customField.id]) : '';
    }

    getValue(item) {return !!item.customFieldsData[this.customField.id] ? this._normalizeRatingValue(item.customFieldsData[this.customField.id]) : null;}

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.AVERAGE}

    listItemGroupFunction() {
        return i=>this._normalizeRatingValue(i.item.customFieldsData[this.customField.id])
    }

    listItemSortFunctions(sort) {
        return {
            functions: [
                i => !!sort ? 0 : !!i.item.customFieldsData[this.customField.id] ? 1 : 2,
                i => i.item.customFieldsData[this.customField.id] || 0
            ],
            directions: ['asc', sort]
        }
    }

    get ListComponent() {
        return ListComponent.bind(null, this.customField.id);
    }

    get ListGroupHeaderComponent() {
        return ListGroupHeaderComponent.bind(null, this.customField.id);
    }

    get TListGroupHeader1Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get TListGroupHeader2Component() {
        return TListGroupHeader1Component.bind(null, this.customField.id);
    }

    get ViewComponent() {
        return ViewComponent.bind(null, this.customField.id);
    }

    get EditComponent() {
        return EditComponent.bind(null, this.customField.id);
    }

    get FormAddComponent() {
        return FormComponent;
    }

    get FormNewComponent() {
        return FormNewComponent.bind(null, this.customField.id);
    }

    get AggregateComponent() {
        return AggregateRatingComponent.bind(null, this.getAggregateOptions(), this.customField.params);
    }

    // IMPORT

    normalizeCSVValue(value) {
        return normalizeNumber(value);
    }

    getComponentViewInImport() {
        return FieldRatingViewInImport;
    }
}